<h1 mat-dialog-title class="aza-pa-dialog-title">{{data.title}}</h1>

<div *ngIf="isLoaded" mat-dialog-content class="aza-pa-dialog-content">
    <azavista-input-field (valueChanged)="onFieldValueChanged($event)" [field]="field" [value]="fieldValue"
        [editMode]="true" [canEdit]="true" [options]="fieldOptions" [fullWidth]="true"></azavista-input-field>
</div>

<div mat-dialog-actions class="aza-pa-dialog-actions">
    <azavista-button (click)="onCancel()" class="aza-pa-dialog-action-cancel-button"><span translate>CANCEL</span></azavista-button>
    <azavista-button (click)="onCreate()" color="primary" class="aza-pa-dialog-action-apply-button"><span translate>CREATE</span>
    </azavista-button>
</div>
